import React from "react";
import { Dialog } from "primereact/dialog";
import VitalSignForm from "./vital-signs-form/vital-sign-form";

const VitalSigns = ({ setShow, show, vitals, handleVitalsSubmit, patient }) => {
    return (
        <Dialog
            visible={show}
            style={{ width: "95vw", maxWidth: "480px" }}
            contentStyle={{ padding: "12px 16px 16px", overflowY: "auto", maxHeight: "75vh" }}
            headerClassName="text-sm font-bold text-gray-800 px-4 pt-4 pb-2"
            header="Vital Signs"
            breakpoints={{ "960px": "95vw" }}
            onHide={() => setShow(false)}
        >
            <VitalSignForm
                patient={patient}
                handleVitalsSubmit={handleVitalsSubmit}
                setVisitDetails={{}}
                visitDetails={{}}
                updateState={{}}
                setShow={setShow}
                previousVitals={vitals}
            />
        </Dialog>
    );
};

export default VitalSigns;
